import {BaseComponent} from "./base.component";
import {BreadcrumbItem} from "../../modules/common/modules/generic/breadcrumb/breadcrumb.model";
import {EventBusService} from "../services/eventbus/event-bus.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SubscriptionContainerService} from "../services/subscription-container.service";
import {Component, EventEmitter, Inject, Output} from "@angular/core";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {BaseConfig} from "../models/baseConfig";
import {BaseDialogComponent} from "./base-dialog.component";
import {hingeInFromTop} from "../animations/component.animation";
import {
  BasicFilterData,
  parseFilterData,
  toParams
} from "../../modules/common/modules/utility/components/basic-filter/basic-filter.model";

@Component({
  template: '',
  animations: [
    hingeInFromTop("loaded")
  ]
})
export abstract class BaseUpsertComponentV2<RESULT> extends BaseComponent implements BaseDialogComponent<RESULT> {

  breadcrumbItems: BreadcrumbItem[] = []

  @Output() onCanceled: EventEmitter<void> = new EventEmitter<void>()
  @Output() onCompleted: EventEmitter<RESULT | null> = new EventEmitter<RESULT | null>()

  private filterData: BasicFilterData | null = null
  exId: number | null = null

  dialogUpsert: boolean = false

  protected constructor(
    eventBus: EventBusService,
    router: Router,
    subContainer: SubscriptionContainerService,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) private dialogData: any
  ) {
    super(eventBus, router, subContainer);
    this.breadcrumbItems = this.getBreadcrumbItems();
    this.dialogUpsert = dialogData.dialogUpsert != null
  }

  override ngOnInit(): void {
    this.loading = false

    this.route.queryParams.subscribe(params => {
      this.filterData = parseFilterData(params)
    })

    this.route.paramMap.subscribe(paramMap => {
      let exId = paramMap.get('id');
      if (exId == null) exId = this.dialogData?.id
      if (exId != null) {
        let parsed = parseInt(exId)
        if (!isNaN(parsed)) {
          this.exId = parsed
          this.initialize(this.exId)
        }
      }
    })
  }


  navigateToListPage(then: ((value: any) => void) | null = null) {
    this.router.navigate([this.getListPageRoute()], {
      queryParams: this.filterData == null ? null : toParams(this.filterData)
    }).then(then)
  }

  onSuccess(result: RESULT | null) {
    this.loading = false;
    if (this.dialogUpsert || this.getConfig().upsertOnDialog) {
      this.onCompleted.emit(result)
    } else {
      this.navigateToListPage()
    }
  }

  onCancel() {
    if (this.dialogUpsert || this.getConfig().upsertOnDialog) {
      this.onCanceled.emit()
    } else {
      this.navigate(this.getListPageRoute(), value => {
      })
    }
  }

  protected abstract getBreadcrumbItems(): BreadcrumbItem[];

  abstract initialize(exId: number): void

  abstract getConfig(): BaseConfig

  abstract getListPageRoute(): string
}
